jQuery(document).ready(function onCheckoutReady($) {
    "use strict";

    var $form = $('#contactinfo form');
    var $cart = $('#quotation-request');
    var $info = $('#contactinfo');
    var $thanks = $('#contactsuccess');

    $form.on('submit', validate_form_and_checkout);
    $form.find('[data-validate]').on('change', function onChangeInput() {
        var $this = $(this);
        if($this.hasClass('validation--failed'))
            $this.removeClass('validation--failed');
        $form.find('.error-information').slideUp();
    });

    function process_validation() {
        var hasError = false;
        $form.find('[data-validate]').each(function eachValidateInput() {
            var $this = $(this);
            var value = $this.val();
            var field = $this.attr('name');

            var rules = $this.attr('data-validate').split(',');
            for(var i = 0, l = rules.length, rule, hasLocalError; i < l; ++i) {
                rule = rules[i];

                hasLocalError = false;

                switch(rule) {
                    case 'required':
                        if(value.length === 0)
                            hasLocalError = true;
                        break;
                    case 'email':
                        if(!is_valid_email(value))
                            hasLocalError = true;
                        break;
                }

                if(hasLocalError) {
                    hasError = true;
                    show_error_message_for_field(field, rule);
                    break;
                }
            }
        });

        return !hasError
    }

    function is_valid_email(email) {
        var expression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return expression.test(email);
    }

    function show_error_message_for_field(field, rule) {
        var $field = $form.find('input[name="' + field + '"]');
        var $error = $field.siblings('.error-information--' + rule);
        $error.slideDown();
        $field.addClass('validation--failed');
    }

    function validate_form_and_checkout(e) {
        e.preventDefault();
        /*if(!process_validation()) {
            return;
        }*/

        $form.find('button[type="submit"]').hide();
        $form.find('.loading-indicator').show();

        var data = {
            action: 'cyklos_checkout'
        };

        $form.find('input, select, textarea').each(function eachInput() {
            var $this = $(this);
            data[$this.attr('name')] = $this.val();
        });

        $.post(checkout.checkout_url, data, null, 'json')
            .success(onSubmitSuccess)
            .always(onSubmitAlways);
    }

    function onSubmitSuccess(response) {
        if(!response.ok) {
            if(response.status === 'validation_fail') {
                show_error_message_for_field(response.extra.field, response.extra.rule);
            } else {
                alert('Oväntat fel vid offertbegäran. Kontakta Cyklos.');
            }

            return;
        }

        if(!response.success && response.status === 'validation_failed') {
            show_error_message_for_field(response.extra.field);
        }

        $('.cart_count').remove();
        $cart.hide();
        $info.hide();
        $thanks.show();
        $('html, body').animate({
            scrollTop: $('#main').offset().top
        });
    }

    function onSubmitAlways() {
        $form.find('.loading-indicator').hide();
        $form.find('button[type="submit"]').show();
    }
});